<div class="main-container">
  <div class="top-section">
    <img class="logo" src="assets/logo/logo-full-green.png" alt="Check Plus Logo" />
  </div>

  <div class="back-button-container">
    <div class="back-button" (click)="goBack()">
      <mat-icon>chevron_left</mat-icon>
      <span>Back to Home</span>
    </div>
  </div>

  <div class="cards-container">
    <div class="selection-card" id="admin-card">
      <div class="card-content">
        <img src="assets/sing-up/company_owner.svg" alt="Company Owner" class="role-icon" />
        <h3>Company Owner or Administrator</h3>
        <p>Set up Check Plus for your company.</p>
      </div>
      <div class="arrow-container" (click)="onAdminClick()">
        <mat-icon>arrow_forward</mat-icon>
      </div>
    </div>

    <div class="selection-card" id="employee-card">
      <div class="card-content">
        <img src="assets/sing-up/company_employee.svg" alt="Company Employee" class="role-icon" />
        <h3>Company Employee</h3>
        <p>Review or make corporate requests and track their status</p>
      </div>
      <div class="arrow-container" (click)="onEmployeeClick()">
        <mat-icon>arrow_forward</mat-icon>
      </div>
    </div>
  </div>
</div>
